const getTDefaultOptions = (key, tOptions = {}, site) => {
  const defaultValue = tOptions.defaultValue || key;
  return {
    ...tOptions,
    defaultValue,
    city: site?.city_relation?.title,
    site: site?.descriptions?.[0]?.title,
    "site-url": site?.domain,
  };
}

module.exports = getTDefaultOptions;